module.exports = __webpack_public_path__ + "static/media/flag-rectangle-ko.7992881b.png";